import React from "react";
import { HexAlphaColorPicker } from "react-colorful";

interface ColorPickerContentProps {
  color: string;
  onChange: (newColor: string) => void;
}

/**
 * Shared content for the color picker across the application.
 * Includes the floating tooltip logic for opacity.
 */
export const ColorPickerContent: React.FC<ColorPickerContentProps> = ({
  color,
  onChange,
}) => {
  // Calculate opacity percentage once here
  const alphaValue = Math.round(
    (parseInt((color.length === 9 ? color : color + "ff").slice(7, 9), 16) / 255) *
      100
  );

  return (
    <div
      className="alpha-tooltip p-1"
      style={
        {
          "--alpha-value": `"${alphaValue}%"`,
          "--current-color": color,
        } as React.CSSProperties
      }
    >
      <HexAlphaColorPicker color={color} onChange={onChange} />
    </div>
  );
};
